import React from 'react';

import { type IMicrofrontendManifest } from '@cian/mf-registry/shared';

import { CountrysideMain } from '../../components/countryside/Main/Main';
import { BackgroundProvider } from '../../components/countryside/BackgroundProvider';
import { CountrysideHeader } from '../../components/countryside/Header/Header';
import { FiltersPanel } from '../../components/countryside/FiltersPanel/FiltersPanel';
import { CountrysideFiltersTabsContainer } from '../countryside/CountrysideFiltersTabsContainer/CountrysideFiltersTabsContainer';
import { CountrysideFiltersContainer } from '../countryside/CountrysideFiltersContainer/CountrysideFiltersContainer';
import { BrandBannerContainer } from '../BrandBannerContainer';
import { RecommendationsContainer } from '../RecommendationsContainer';
import { CountrysideVillagesContainer } from '../countryside/VillagesContainer/VillagesContainer';
import { CountrysideReviewsContainer } from '../countryside/ReviewsContainer/ReviewsContainer';
import { CountrysideMagazineContainer } from '../countryside/CountrysideMagazineContainer/CountrysideMagazineContainer';
import { GeoSwitcherWrapperContainer } from '../GeoSwitcherContainer';
import { useApplicationContext } from '../../utils/applicationContext';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from '../../constants/microfrontend';

export const CountrysideHomeContainer = () => {
  const { config } = useApplicationContext();

  /**
   * Фича-флаг микрофронтенда рекламного баннера: манифест сериализуется в браузерный
   * конфиг только при включённом MarTech.AdBannerMicrofrontend.Enabled. Есть манифест —
   * рекламу рисует микрофронтенд поверх шапки, нет — легаси-баннер с BackgroundProvider.
   */
  const isAdBannerMicrofrontendEnabled = Boolean(config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY));

  const filtersPanel = (
    <FiltersPanel>
      <CountrysideFiltersTabsContainer />
      <CountrysideFiltersContainer />
    </FiltersPanel>
  );

  return (
    <CountrysideMain>
      <GeoSwitcherWrapperContainer />
      {isAdBannerMicrofrontendEnabled ? (
        <CountrysideHeader adBannerMicrofrontendEnabled>{filtersPanel}</CountrysideHeader>
      ) : (
        <BackgroundProvider>
          <CountrysideHeader>
            {filtersPanel}
            <BrandBannerContainer />
          </CountrysideHeader>
        </BackgroundProvider>
      )}
      <RecommendationsContainer />
      <CountrysideVillagesContainer />
      <CountrysideReviewsContainer />
      <CountrysideMagazineContainer />
    </CountrysideMain>
  );
};
